import { BaseType, BuildComponentTypeDefinition } from '../types/Enums';

/**
 * Component types iOS writes by fixed key, so every instance needs them in
 * `config/buildComponentTypes`. An admin creates the missing ones from the setup
 * banner or Konfigurationsstatus, never on page open. Name only: the lifetime and
 * cost are set afterwards in Komponenttyper.
 */
export interface RequiredDefaultType {
    key: string;
    baseType: BaseType;
    name: string;
}

export const REQUIRED_DEFAULT_TYPES: RequiredDefaultType[] = [
    // iOS LockMechanismModel creates every lock with this specificType
    { key: 'lock_mechanism_default', baseType: BaseType.LockMechanism, name: 'Lås' },
];

/** The required default types not present in the given `config/buildComponentTypes` node. */
export const missingDefaultTypes = (types: Record<string, unknown> | null | undefined): RequiredDefaultType[] =>
    REQUIRED_DEFAULT_TYPES.filter(entry => !types?.[entry.key]);

/** The node a missing default type is created with. */
export const defaultTypeDefinition = (
    entry: RequiredDefaultType,
    createdBy: string,
    createdAt: string
): BuildComponentTypeDefinition => ({
    baseType: entry.baseType,
    translations: { sv: entry.name },
    createdBy,
    createdAt,
});
